import socketio from '@/common/utils/socketio.connection';
import AuthorizationError from '@/common/utils/errors/AuthorizationError';
import useAuthStore from '@/common/store/pinia/auth';
import isSelfService from '@/common/utils/isSelfService';

const setAuthRequestHeaders = (sessionId, token) => ({
  polling: {
    extraHeaders: {
      // We use x-session-id to separate self-service sessionId from the hci sessionId
      // The value of "x-session-id" is added at the end of a cookie's name
      // Accepted that value is static and equal to '1' for self-service sessionId
      'x-session-id': sessionId,
      'x-auth-token': token
    }
  }
});

const actions = {
  CONNECT() {
    const authStore = useAuthStore();
    if (isSelfService() && !authStore.getScopedToken) {
      throw new AuthorizationError();
    }

    const sessionId = isSelfService() ? '1' : '0';
    socketio.io.opts.transportOptions = setAuthRequestHeaders(sessionId, authStore.getScopedToken);
    socketio.open();
  },
  DISCONNECT({ commit }) {
    commit('SOCKET_AUTHORIZED', false);
    socketio.close();
  },
  SOCKET_AUTHORIZED({ commit }) {
    commit('SOCKET_AUTHORIZED', true);
  },
  socket_connect({ state, dispatch }) {
    // There is a race condition in socket.io
    // https://github.com/socketio/socket.io/issues/2273#issuecomment-172378405
    let loginTriesCount = 0;
    const authStore = useAuthStore();
    const socketLogin = () => setTimeout(() => {
      if (state.authorized) {
        return;
      }
      if (loginTriesCount >= 3) {
        console.warn('bad ws connection: reconnection attempt');
        dispatch('DISCONNECT');
        dispatch('CONNECT');
        return;
      }
      loginTriesCount++;
      const token = authStore.getScopedToken;
      if (token) {
        socketio.emit('login', { all_tenants: !isSelfService() });
      }
      socketLogin();
    }, 1000);

    socketLogin();
  },
  async socket_json({ dispatch }, payload) {
    if (payload.code === 200) {
      dispatch('SOCKET_AUTHORIZED');
    } else if (payload.code === 401) {
      dispatch('DISCONNECT');
      const authStore = useAuthStore();
      await authStore.signOut();
    } else if (payload.code >= 500) {
      dispatch('DISCONNECT');
      setTimeout(() => {
        dispatch('CONNECT');
      }, 5000);
    }
  },
};

export default actions;
